import { ContactCornSchema } from '@eigtech/contacts-types';
import { SubtotalLineItemSchema } from '@eigtech/line-items';
import { z } from 'zod';
import { BaseInvoicingSchema, InvoicingTypeEnum } from './service.js';
import { StatusEnum } from './status.js';
export const BillStatusSchema = z.enum([StatusEnum.pending, StatusEnum.created]);
export const BillStatusEnum = BillStatusSchema.enum;
export const BillingVendorSchema = z.object({
    name: z.string().optional(),
    id: z.string().optional(),
    contactId: ContactCornSchema,
});
export const BillSchema = BaseInvoicingSchema.extend({
    type: z.literal(InvoicingTypeEnum.bill),
    vendor: BillingVendorSchema,
    total: SubtotalLineItemSchema,
});
export const PaidBillSchema = BillSchema.extend({
    status: z.literal(StatusEnum.paymentMade),
});
export const isBill = (entity) => BillSchema.safeParse(entity).success;
export const isPaidBill = (entity) => PaidBillSchema.safeParse(entity).success;
